<template>
  <div>
    <zj-layout-container class="user-layout">
      <div class="zj-layout-left">
        <div class="zj-left-main">
          <el-tree
            style="{ width }"
            :data="Orgs"
            :props="defaultProps"
            @node-click="handleNodeClick"
            highlight-current="true"
          ></el-tree>
        </div>
      </div>
      <div class="zj-layout-right">
        <zj-layout-header>
          <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
            <el-form-item label="角色名称">
              <el-input placeholder="请输入角色名称" v-model="Role_Name"></el-input>
            </el-form-item>
            <el-form-item label class="right">
              <el-button @click="onSearch">查 询</el-button>
              <el-button @click="onCancel">清 理</el-button>
            </el-form-item>
          </el-form>
          <el-divider></el-divider>
        </zj-layout-header>
        <zj-layout-main>
          <div class="zj-button-bar">
            <el-button size="mini" @click="onAdd">添 加</el-button>
            <el-button size="mini" @click="onbatchDel">删 除</el-button>
          </div>
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="RoleName" label="角色名称"></el-table-column>
              <el-table-column prop="Description" label="备注">
                <template slot-scope="scope">
                  <el-popover placement="top-start" title="备注" width="250" trigger="hover">
                    <div>{{scope.row.Description}}</div>
                    <span
                      slot="reference"
                    >{{ (scope.row.Description!=null &&scope.row.Description.length>30)?scope.row.Description.substr(0,30)+'...':scope.row.Description }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                  <el-button
                    @click="deleteClick(scope.$index,scope.row)"
                    type="text"
                    size="small"
                  >删除</el-button>
                  <el-button type="text" size="small" @click="setRights(scope.$index,scope.row)">授权</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </zj-layout-main>
        <zj-layout-footer>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5,10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="total"
          ></el-pagination>
        </zj-layout-footer>
      </div>
    </zj-layout-container>
    <ZjDialog
      :title="dilaogconfig.title"
      :dialogFormVisible="dilaogconfig.dialogFormVisible"
      :width="dilaogconfig.width"
      :height="dilaogconfig.height"
      @clickCancel="handleDialogCancel"
    >
      <RoleInfoPage
        @clickOk="handleDialogOk"
        @clickCancel="handleDialogCancel"
        :Role_Id="this.SelectedRoleId"
        :Org_Id="this.SelectedOrg.OrgId"
      ></RoleInfoPage>
    </ZjDialog>
    <ZjDialog
      :title="RightsDilaogconfig.title"
      :dialogFormVisible="RightsDilaogconfig.dialogFormVisible"
      :width="RightsDilaogconfig.width"
      :height="RightsDilaogconfig.height"
      @clickCancel="RishtshandleDialogCancel"
    >
      <RoleMenusPage
        @clickOk="RightshandleDialogOk"
        @clickCancel="RishtshandleDialogCancel"
        :Role_Id="this.SelectedRoleId"
      ></RoleMenusPage>
    </ZjDialog>
  </div>
</template>

<script>
import utils from "../../../../../../utils";
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";
import RoleInfoPage from "./roleinfo.vue";
import RoleMenusPage from "./rolemenus.vue";

export default {
  name: "RolesPage",
  controller: "UI",
  action: "roles",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      Orgs: null,
      SelectedOrg: "",
      defaultProps: {
        children: "OrgInfos",
        label: "OrgName"
      },
      Role_Name: "",
      SelectedRoleId: "",
      tableHeight: window.innerHeight - 440,
      dilaogconfig: {
        title: "添加角色",
        dialogFormVisible: false,
        width: "900px"
      },
      RightsDilaogconfig: {
        title: "授权",
        dialogFormVisible: false,
        width: "400px"
      },
      multipleSelection: []
    };
  },
  components: {
    RoleInfoPage,
    RoleMenusPage
  },
  props: {
    width: {
      type: String,
      default: "200px"
    }
  },
  created: function() {
    this.init();
  },
  mounted: function() {
    const that = this;
    window.onresize = () => {
      return (() => {
        console.log("window.innerHeight=" + window.innerHeight);
        that.tableHeight = window.innerHeight - 440;
      })();
    };
    this.GetRoles();
    this.logInfo.ActionName = "角色管理查看";
    this.logInfo.LogMessage = "角色管理查看";
    this.logInfo.ModuleName = "权限管理";
    this.logInfo.PageName = "角色管理页面";
    this.addOperationLog();
  },
  computed: {},
  methods: {
    // 初始化
    init() {
      return utils.waitAll([() => this.GetOrgsByUserId()]);
    },
    GetOrgsByUserId() {
      showLoading(".zj-table-container");

      let user = this.user;
      let userId = user.UserId;

      let TreeSearch = {
        UserId: userId
      };
      return new WebApis.TreeApi()
        .GetOrgTreeByUserId(TreeSearch)
        .then(res => {
          this.Orgs = res.data.Data;
          this.GetRoles();
          hideLoading();
        })
        .catch(e => {
          hideLoading();
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取组织机构失败!" + e.RspMsg
              : "获取组织机构失败!",
            type: "error"
          });
        });
    },
    GetRoles() {
      showLoading(".zj-table-container");

      let Org = this.Orgs ? this.Orgs[0] : undefined;
      let OrgIdArray = Org ? this.GetOrgArray(Org) : [];
      let RoleInfoSearch = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        RoleName: this.Role_Name,
        OrgId: this.SelectedOrg ? this.SelectedOrg.OrgId : "",
        OrgIds: OrgIdArray,
        TotalCount: 0
      };
      return new WebApis.RoleApi()
        .GetItemPagingList(RoleInfoSearch)
        .then(r => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          hideLoading();
        })
        .catch(e => {
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取角色数据异常！" + e.RspMsg
              : "获取角色数据异常！",
            type: "error"
          });
          hideLoading();
          return null;
        });
    },
    GetOrgArray(Org) {
      var OrgIds = [];
      if (Org) {
        if (Org.OrgInfos) {
          Org.OrgInfos.forEach(each => {
            OrgIds.push(each.OrgId);
            var Org_Ids = this.GetOrgArray(each);
            Org_Ids.forEach(each1 => {
              OrgIds.push(each1);
            });
          });
        }
      }
      return OrgIds;
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.GetRoles();
    },
    onCancel() {
      this.clearsearch();
      this.GetRoles();
    },
    clearsearch() {
      this.Role_Name = "";
      this.SelectedRoleId = "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetRoles();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetRoles();
    },
    handleNodeClick(data) {
      this.SelectedOrg = data;
      this.GetRoles();
    },
    formatTime(row, column) {
      const date = new Date(row[column.property]);
      return (
        date.getFullYear() +
        "年" +
        date.getMonth() +
        "月" +
        date.getDate() +
        "日"
      );
    },
    onAdd() {
      if (!this.SelectedOrg) {
        this.$message({
          showClose: true,
          message: "请选择组织机构!",
          type: "warning"
        });
        return;
      }
      this.SelectedRoleId = "";
      this.dilaogconfig.dialogFormVisible = true;
    },
    selectionChange(val) {
      this.multipleSelection = val;
    },
    onbatchDel() {
      let Role_Ids = [];
      this.multipleSelection.forEach(item => {
        Role_Ids.push(item.RoleId);
      });

      if (Role_Ids.length <= 0) {
        this.$message({
          showClose: true,
          message: "请选择要删除的数据!",
          type: "warning"
        });
        return;
      }
      this.$confirm("确定删除选中角色?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let RoleInfoSearch = {
          RoleIds: Role_Ids
        };
        new WebApis.RoleApi()
          .DelItemList(RoleInfoSearch)
          .then(r => {
            if (r.RspCode == "1") {
              this.$message({ type: "success", message: "删除成功!" });
              this.GetRoles();
            } else {
              this.$message({
                showClose: true,
                message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                type: "error"
              });
            }
            this.logInfo.ActionName = "角色删除";
            this.logInfo.LogMessage =
              r.RspCode == "1" ? "角色删除成功" : "角色删除失败";
            this.logInfo.ModuleName = "权限管理";
            this.logInfo.PageName = "角色管理列表页面";
            this.addOperationLog();
          })
          .catch(e => {
            this.$message({
              showClose: true,
              message: e.RspMsg ? "删除失败!" + e.RspMsg : "获取角色信息失败!",
              type: "error"
            });
          });
      });
    },
    editClick(index, row) {
      this.SelectedRoleId = row.RoleId;
      this.dilaogconfig.title = "修改角色";
      this.dilaogconfig.dialogFormVisible = true;
    },
    deleteClick(index, row) {
      this.SelectedRoleId = row.RoleId;
      this.$confirm("确定删除该角色?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let RoleInfoDTO = {
          RoleId: this.SelectedRoleId
        };
        new WebApis.RoleApi()
          .DelItem(RoleInfoDTO)
          .then(r => {
            if (r.RspCode == "1") {
              this.$message({ type: "success", message: "删除成功!" });
              this.GetRoles();
            } else {
              this.$message({
                showClose: true,
                message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                type: "error"
              });
            }
            this.logInfo.ActionName = "角色删除";
            this.logInfo.LogMessage =
              r.RspCode == "1" ? "角色删除成功" : "角色删除失败";
            this.logInfo.ModuleName = "权限管理";
            this.logInfo.PageName = "角色管理列表页面";
            this.addOperationLog();
          })
          .catch(e => {
            this.$message({
              showClose: true,
              message: e.RspMsg ? "删除失败!" + e.RspMsg : "获取角色信息失败!",
              type: "error"
            });
          });
      });
    },
    setRights(ndex, row) {
      this.SelectedRoleId = row.RoleId;
      this.RightsDilaogconfig.dialogFormVisible = true;
    },
    handleDialogOk() {
      this.dilaogconfig.dialogFormVisible = false;
      this.GetRoles();
    },
    handleDialogCancel() {
      this.dilaogconfig.dialogFormVisible = false;
    },
    RightshandleDialogOk() {
      this.RightsDilaogconfig.dialogFormVisible = false;
    },
    RishtshandleDialogCancel() {
      this.RightsDilaogconfig.dialogFormVisible = false;
    }
  }
};
</script>